<template>
    <div class="exampleCase">
        <div :class="{'banner':true,'blankBanner':!bannerUrl}">
            <img style="width:100%;cursor:pointer" @click="changeLink()" :src="bannerUrl" alt="">
        </div>
        
            <div class="box1">
                <div class="content">
                <ul>
                    <li>
                        <div class="text">
                            <div class="title">本科院校</div>
                        </div>
                    </li>
                    <li>
                        <div class="text">
                            <div class="title">职业院校</div>
                        </div>
                    </li>
                    <li>
                        <div class="text">
                            <div class="title">远程教育</div>
                        </div>
                    </li>
                </ul>
                </div>
            </div>
            <div class="box2">
                <div class="content">
                <div class="commonTitle">
                    <div class="top">客户案例</div>
                    <div class="bottom">CUSTOMER CASE</div>
                </div>
                <div class="imgWrap">
                    <div class="modal">
                        <img src="../assets/exampleItem1.png" alt="">
                        <div>沈阳中港投资华中数控智能制造应用示范基地</div>
                    </div>
                    <div class="modal">
                        <img src="../assets/exampleItem2.png" alt="">
                        <div>沈阳中港投资华中数控智能制造应用示范基地</div>
                    </div>
                </div>
                <div class="imgWrap">
                    <div class="modal">
                        <img src="../assets/exampleItem3.png" alt="">
                        <div>邢台技师学院产教融合基地</div>
                    </div>
                    <div class="modal">
                        <img src="../assets/exampleItem4.png" alt="">
                        <div>佛山市华材职业技术学院</div>
                    </div>
                </div>
                <div class="imgWrap">
                    <div class="modal">
                        <img src="../assets/exampleItem5.png" alt="">
                        <div>重庆工商职业技术学校</div>
                    </div>
                    <div class="modal">
                        <img src="../assets/exampleItem6.png" alt="">
                        <div>包头机械</div>
                    </div>
                </div>
                </div>
            </div>
        </div>
</template>
<script>
import {getBannerListApi} from "@/request/api"
export default {
    name:"exampleCase",
    data(){
        return{
            bannerUrl:'',
            bannerLink:''
        }
    },
    mounted(){
        this.init()
    },
    methods:{
        init(){
            this.getToken(getBannerListApi,{},res=>{
                this.bannerUrl=res.data.filter(item=>item.link==5)[0].banner_img
                this.bannerLink=res.data.filter(item=>item.link==5)[0].banner_name
            })
        },
        changeLink(){
            if(this.bannerLink){
                window.open(this.bannerLink, '_blank')
            }
        }
    }
}
</script>
<style lang="stylus" scoped>
.exampleCase
    background:#f8f8f8;
    .content
        width:1200px;
        margin:0 auto;
    .commonTitle
        width:100%;
        text-align center;
        margin-top:54px;
        height:156px;
        .top
            font-size:34px;
            color:#333;
            margin-bottom:12px;
        .bottom
            font-size:16px;
            color:#999;
    .imgWrap
        display:flex;
        justify-content:space-between;
        .modal  
            width:49%;
            margin-bottom:40px;
            &:hover
                box-shadow:1px 5px 10px #ddd;
            img 
                width:100%;
            div
                height:72px;
                line-height:72px;
                background:#fff;
                font-size:18px;
                color:#333;
                text-align:center;
    
    .box1
        width:100%;
        background:#fff;
        height:370px;
        ul
            display:flex;
            justify-content:space-between;
            li
                width:378px;
                height:300px;
                background:url('../assets/example1.png')
                background-repeat: no-repeat
                margin-top:75px;
                position:relative;
                &:nth-child(2)
                    background:url('../assets/example2.png') no-repeat;
                &:nth-child(3)
                    background:url('../assets/example3.png') no-repeat;
                .text
                    position:absolute;
                    top:50%;
                    left:50%;
                    width:100%;
                    text-align:center;
                    transform:translate(-50%,-50%)
                    .title
                        font-size:30px;
                        color:#333;
                        margin-bottom:70px;
                   
</style>
